export const getVoucherInboxPath = (voucherId: string, route: string): string => {
  return `/inbox/voucher-inbox/${voucherId}/${route}`
}
